export const LOGIN_USER = 'LOGIN_USER';
export const CHECK_USER = 'CHECK_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const REGISTER_USER = 'REGISTER_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';

export const GET_SETTINGS = 'GET_SETTINGS';
export const CHANGE_SETTINGS = 'CHANGE_SETTINGS';

export const GET_EMAILS = 'GET_EMAILS';
export const SET_EMAIL = 'SET_EMAIL';
export const DELETE_EMAIL = 'DELETE_EMAIL';

export const GET_TASKS = 'GET_TASKS';
export const GET_TASK = 'GET_TASK';
export const CREATE_TASK = 'CREATE_TASK';
export const MOVE_TASK = 'MOVE_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const DELETE_TASK = 'DELETE_TASK';

export const TAG_TASK = 'TAG_TASK';
export const GET_TAG_TASKS = 'GET_TAG_TASKS';
